import { PropsWithChildren } from 'react';

import { StyledLayoutContainer, StyledLayoutMain } from './styles';

export const LayoutMain: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledLayoutContainer>
      <StyledLayoutMain>{children}</StyledLayoutMain>
    </StyledLayoutContainer>
  );
};
